<template>
  <div class="wrapper-privacy--en">
    <ol class="sections-title">
      <p
        >Welcome to LocalAdventures.travel. As part of our mission to deliver
        the most unique adventures Mexico has to offer, Stuntshare Inc. and its
        affiliates, including LocalAdventures, collect and process a lot of
        information. Our Privacy Policy is listed below to help you better
        understand how we collect, use, and store your personal information. By
        using any of LocalAdventures’s Services, you are agreeing to the terms
        of this Privacy Policy as well as to the Terms and Conditions.</p
      >
      <li>
        <p class="title"
          >Responsible for the Protection of your Personal Data</p
        >

        <p
          >Stuntshare Inc, (hereinafter "Local Adventures"), is responsible for
          the processing of your personal data, of the use given to them and
          their protection.</p
        >
        <p
          >To contact us, please dial the telephone number (+52) 33 363 2547 5
          or send an email to the following address:
          <a href="mailto:info@localadventures.travel"
            >info@localadventures.travel</a
          ></p
        >
        <p
          >Within a period of 3 calendar days after the effective date of this
          Privacy Notice or, as the case may be, any of its subsequent updates,
          you must express your opposition to the processing of your personal
          data by <span class="localadventures u">LOCAL ADVENTURES</span> by
          sending an email to the address mentioned in the previous paragraph.
        </p>
        <p
          >Once the aforementioned period has elapsed, your tacit acceptance of
          the guidelines and provisions established in this Privacy Notice will
          be understood.
        </p>
      </li>
      <li>
        <p class="title">Personal data we collect</p>
        <p
          >For the purposes set forth in this Privacy Notice, we inform you that
          we may collect your personal data in the following ways:</p
        >

        <ul>
          <li>Directly when you provide them to us.</li>
          <li
            >When you visit our website
            <a href="https://localadventures.travel/"
              >www.localadventures.travel</a
            ></li
          >
          <li
            >When we obtain information through other means permitted by current
            applicable legislation..</li
          >
        </ul>

        <p
          >The foregoing in accordance with the following information that will
          be requested:</p
        >
        <ul>
          <li
            >The personal data that we can collect directly, are those that you
            provide us (either orally or in writing) such as name, telephone
            number, full address, payment information, federal taxpayer
            registration, bank account, number of credit card (data that is not
            saved, it is simply used by the payment processor) and IP address
            (this is in order to be able to see if a sale is true or not, it is
            used to see if someone tried to do fraud before with that IP)
            email.</li
          >
          <li
            >The personal data that we can collect when you visit our website
            are your name, email address, full address (billing and shipping),
            telephone, payment data, credit card (data that is not saved, simply
            uses the payment processor), and IP address (this is in order to be
            able to see if a sale is true or not, it is used to see if someone
            tried to do fraud before with that IP).</li
          >
          <li
            >The personal data that we can obtain by other means permitted by
            current applicable legislation or resolutions of any competent
            authority empowered for such purposes, such as name, place and job,
            email address, data related to the source (company) From his
            job.</li
          >
        </ul>
      </li>
      <li>
        <p class="title">Purpose and Use of your Personal Data</p>

        <p
          >The personal data collected in accordance with the provisions of the
          previous paragraph will be used to: Offer a tool to adventure
          travelers where they can find everything they need for their
          experience (concept defined in the Terms and Conditions indicated on
          the website
          <a href="https://localadventures.travel/"
            >www.localadventures.travel</a
          >) in favor of the <span class="operator u">Supplier</span>, to
          authorize the experiences and/or rental of sports equipment, as well
          as make the corresponding deposits for both the
          <span class="operator u">Supplier</span> and the
          <span class="client u">Client</span>.</p
        >

        <h3
          >We will process personal data for the following purposes secondary or
          accessory:</h3
        >

        <ol>
          <li>
            Marketing, advertising, promotion, commercial prospecting, referral
            processes, the preparation, evaluation and analysis of User profiles
            for the development and offering of new products and services,
            conducting surveys outside our products or services, analytical and
            statistical purposes, all of them related to the products and
            services of the Controllers, their affiliates, subsidiaries, allies
            and other third parties.</li
          >
          <li
            >To contact you about or send you news information, news, offers
            from the Controllers or third parties, newsletters, forums
            education, advertising or marketing, distance selling, making use of
            media such as, but not limited to, email, PUSH notifications, text
            messages (SMS), messaging snapshots, calls and dialog windows
            (pop-ups).</li
          >
        </ol>
      </li>
      <li>
        <p class="title">Treatment of Sensitive Personal Data</p>
        <p
          ><span class="localadventures u">LOCAL ADVENTURES</span> does not
          collect sensitive personal data (such as data of racial or ethnic
          origin, present and future health status, genetic information,
          religious beliefs, moral philosophy, union affiliation, political
          opinions, sexual preference), however, if by any action, fact or
          circumstance we were to obtain personal data of this nature,
          <span class="localadventures u">LOCAL ADVENTURES</span> undertakes
          that said data will be treated under the strictest security standards
          and measures that will guarantee its confidentiality.</p
        >
      </li>
      <li>
        <p class="title"
          >Limitation of the Use or Disclosure of Personal Data</p
        >
        <p
          >As you would expect, we must provide certain information to
          third-party partners and suppliers to facilitate your booking and
          provide you with the service(s) you have requested.</p
        >
        <p
          >LocalAdventures will share your information with the outside
          suppliers (such as guides, travel companies, hotel companies,
          insurance companies, equipment suppliers, promotional co-sponsors, and
          credit card processing entities etc., all of which may be located
          outside your country of residence and be governed by different privacy
          legislation) who perform services on our behalf. We provide these
          companies with only the information they need to perform their
          services and we work closely with them to ensure that your privacy is
          respected and protected. Please be assured that these companies are
          prohibited by contract from using this information for their own
          marketing purposes and from sharing this information with anyone
          beyond the ordinary course of conducting the companies’ business.</p
        >
        <p>The disclosure of personal data will be limited to the following:</p>
        <ol>
          <li>
            The Provider's data will be transferred to the Client once the
            latter has contributed to the experience or rental of the Provider's
            sports equipment.</li
          >
          <li
            >The Client's data will be transferred to the Provider at the time
            he has contributed to the experience or rental of sports equipment
            from the Provider.</li
          >
          <li
            >The data of the Provider and the Client will be incorporated into
            the Site, when
            <span class="localadventures u">LOCAL ADVENTURES</span> agrees to
            incorporate some experience or rental of sports equipment on its
            Site, or when a Client voluntarily decides to contribute resources
            to some experience or rental of sports equipment that is find on the
            Site.</li
          >
        </ol>
        <p
          >Likewise,
          <span class="localadventures u">LOCAL ADVENTURES</span> will not
          communicate, share or in any way transfer the personal data collected,
          whether inside or outside the national territory, to third parties
          other than those indicated in numerals 5.1 and 5.2. In the event that
          any transfer of data by
          <span class="localadventures u">LOCAL ADVENTURES</span> must be
          carried out, the prior consent of the owner of said personal data must
          be obtained.</p
        >
      </li>
      <li>
        <p class="title"
          >Rights of Access, Rectification, Elimination and Opposition related
          to Personal Data</p
        >

        <p
          >You will have the right to access your personal data that
          <span class="localadventures u">LOCAL ADVENTURES</span> has collected
          at any time, as long as they are business days and hours through a
          prior request made directly to LOCAL ADVENTURES, through the following
          email
          <a href="mailto:info@localadventures.travel"
            >info@localadventures.travel</a
          >. Likewise, you will have the right to rectify them in case your
          personal data is incomplete or inaccurate, as well as to eliminate
          them from our records at any time. Finally, you may object to the
          processing of your personal data for specific purposes.</p
        >
        <p
          >To carry out the exercise of any of the rights mentioned in this
          subsection, you must perform the following steps:</p
        >
        <ol type="a"
          ><li
            >Write a request sent to the following email address:
            <a href="mailto:info@localadventures.travel"
              >info@localadventures.travel</a
            >
            containing the following information:<ul>
              <li
                >Name of the holder and telephone or other means to communicate
                the response to the request.</li
              >
              <li
                >Attach documents that prove the identity of the owner of the
                personal data or, where appropriate, of their legal
                representative with the sufficient and necessary powers for the
                purposes in question.</li
              >
              <li
                >The clear and precise description of the personal data in which
                you want to exercise any of the rights of access, rectification,
                elimination and/or opposition.</li
              >
            </ul></li
          >
          <li
            ><span class="localadventures u">LOCAL ADVENTURES</span> will
            respond to the email where it will be clarified or request
            confirmation about the changes to be made to your personal data.
          </li>
          <li
            >Once you confirm the changes to the email,
            <span class="localadventures u">LOCAL ADVENTURES</span> will make
            the respective changes.</li
          >
        </ol>
        <p
          >In the case where the deletion of data has been requested, the data
          will be deleted from our records and the collection of user data will
          stop at the time the request is confirmed.</p
        >
        <p
          ><span class="localadventures u">LOCAL ADVENTURES</span> must respond
          to the request described above within a period that may not exceed 20
          calendar days from the receipt of said request. In the event that the
          request of the interested party meets all the requirements and,
          therefore, is the same,
          <span class="localadventures u">LOCAL ADVENTURES</span> will have a
          period that will not exceed 15 days from the date of communication of
          the response indicated above to make the request effective. For
          security reasons, we will never return the saved information until we
          have verified the owner's information.</p
        >
      </li>
      <li>
        <p class="title"
          >Revocation of Authorization for the Processing of Personal Data</p
        >

        <p
          >You may revoke the authorization you granted us for the processing of
          your personal data at any time, by sending an email to the address:
          i<a href="mailto:info@localadventures.travel"
            >info@localadventures.travel</a
          >
          containing the following information : (i) the name and address to
          communicate the response to the request, (ii) the sufficient and
          necessary documents that prove the identity of the owner of the
          personal data or, where appropriate, of their legal representative
          with the sufficient and necessary powers for the effects in question,
          (iii) the clear and precise description of the personal data with
          respect to which the revocation is required, and (iv) any other
          document or element that facilitates the location of the personal data
          subject to the aforementioned revocation.
          <span class="localadventures u">LOCAL ADVENTURES</span> must respond
          to the request described in the two preceding paragraphs within a
          period that may not exceed 20 calendar days from the receipt of said
          request. In the event that the request of the interested party meets
          all the requirements and, therefore, it is appropriate,
          <span class="localadventures u">LOCAL ADVENTURES</span> will have a
          period that will not exceed 15 days from the date of communication of
          the response indicated above to make effective application.</p
        >
      </li>
      <li>
        <p class="title">Changes to this Privacy Policy</p>

        <p
          >At some point in time, it may become necessary for LocalAdventuresto
          amend or revise this Privacy Policy. Those revisions may also apply to
          your personal information collected under a previous version of this
          Policy. LocalAdventuresreserves the right to change this Privacy
          Policy at any time and for any reason. If we make a change to the
          Policy, we will post the revised version on our website. If you have
          questions about any of our policies, please contact us.</p
        >
      </li>
      <li>
        <p class="title">Use of Cookies</p>

        <p
          >A web cookie or browser cookie is a small piece of data that a server
          sends to a user's web browser. When you visit a particular website, a
          cookie may be used to track your browser’s activities as well as
          provide you with a consistent, more efficient experience.</p
        >
        <p
          >Third-party vendors, including Google, show LocalAdventures's ads on
          the internet. These third-party vendors use cookies to serve ads based
          on a user's prior visits to LocalAdventures.travel. Third-party
          vendors do not store any personal information in the cookie data.
          Users may opt out of third-party usage of cookies by visiting the
          Network Advertising Initiative opt-out page or by checking the
          settings in their web browsers.</p
        >
        <p
          >Browser cookies may be used to speed up the booking process so that
          you do not need to re-type duplicate information. We may use cookies
          to measure website usage, such as visitors’ entry and exit points and
          the number of people who visit a certain section or page, and learn
          details about searches performed and related information. If you are
          making a purchase, we may also use cookies to track the transaction
          from one page to the next. We do not store any personal information in
          the cookie, nor do we use it for any other purpose.</p
        >
      </li>
      <li>
        <p class="title">Acceptance</p>

        <p
          >This Privacy Notice is subject to the terms and conditions of our
          website
          <a href="https://localadventures.travel/terms-and-conditions"
            >www.localadventures.travel</a
          >, which establishes a legal agreement between the user and the
          company. If the user uses our services, it means that he has read,
          understood and agreed to the terms set forth above.
        </p>
      </li>
    </ol>

    <p><strong>Update date: July 21, 2021</strong></p>
  </div>
</template>

<script>
export default {
  name: 'LadPrivacyEn',
}
</script>
